var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { InteractiveFlowNodes, } from "./InteractiveFlowUtils";
import Tippy from "@tippyjs/react";
import TimeAgo from "../Timeago";
var InteractiveFlowItem = function (props) {
    var getMessageTime = function () {
        return props.execution.created_time * 1000;
    };
    var Node = props.execution.node.type !== "ACTION"
        ? InteractiveFlowNodes[props.execution.node.type]
        : InteractiveFlowNodes[props.execution.node.data.nodeType];
    if (props.execution.node.data.nodeType == "END"
    // &&
    // props.execution.node.data.formData?.action == "agent"
    )
        return _jsx(_Fragment, {});
    else
        return (_jsx(_Fragment, { children: Node ? (_jsx(Tippy, __assign({ content: _jsx(TimeAgo, { date: getMessageTime() }), disabled: false }, { children: _jsx(Node, { execution: props.execution, executeNodeOnUserInteraction: function () { } }) }))) : (_jsx(_Fragment, { children: JSON.stringify(props.execution) })) }));
};
export default InteractiveFlowItem;
